const CHATS_HOSTNAME_PROD = 'https://confluence-chats-integr.services.atlassian.com';
const CHATS_HOSTNAME_STAGING = 'https://confluence-chats-integr.dev.services.atlassian.com';

const POPUP_WIDTH = 500;
const POPUP_HEIGHT = 900;
const POPUP_OPTIONS = {
	toolbar: 0,
	menubar: 0,
	location: 0,
	status: 0,
	scrollbars: 1,
	resizable: 0,
	chrome: 'yes',
};

export const getSlackConsentUrl = (source: string, win: Window = window): string => {
	const isProd = !(
		win.location.hostname.endsWith('jira-dev.com') || win.location.hostname === 'localhost'
	);
	const hostname = isProd ? CHATS_HOSTNAME_PROD : CHATS_HOSTNAME_STAGING;
	return `${hostname}/api/slack/teams/login?source=${source}`;
};

export const openPopup = (url: string, win: Window = window) => {
	const width = Math.min(POPUP_WIDTH, win.screen.availWidth);
	const height = Math.min(POPUP_HEIGHT, win.screen.availHeight);
	const opts = Object.entries({
		...POPUP_OPTIONS,
		width,
		height,
		left: Math.round((win.innerWidth - width) / 2 + win.screenX),
		top: Math.round((win.innerHeight - height) / 3 + win.screenY),
	})
		.map(([key, value]) => `${key}=${value}`)
		.join(',');
	win.open(url, '_blank', opts);
};
